import { getCommunityServiceBaseURL } from '@/lib/configs'

const FCM_TOKENS_ENDPOINT = '/api/notification-service/v1/fcm-tokens'

type RegisterFcmTokenParams = {
  authToken: string
  deviceId: string
  deviceToken: string
  lang: string
}

const parseResponseBody = async (response: Response) => {
  const body = await response.text()

  if (!body) {
    return null
  }

  return JSON.parse(body) as unknown
}

export const registerFCMToken = async ({
  authToken,
  deviceId,
  deviceToken,
  lang,
}: RegisterFcmTokenParams) => {
  const response = await fetch(`${getCommunityServiceBaseURL()}${FCM_TOKENS_ENDPOINT}`, {
    method: 'POST',
    headers: {
      AuthKey: authToken,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      deviceId,
      deviceToken,
      platform: 'web',
      lang,
    }),
  })

  if (!response.ok) {
    throw new Error('Failed to register FCM token')
  }

  return parseResponseBody(response)
}

export const deleteFCMToken = async ({
  authToken,
  deviceId,
}: {
  authToken: string
  deviceId: string
}) => {
  const response = await fetch(
    `${getCommunityServiceBaseURL()}${FCM_TOKENS_ENDPOINT}/${deviceId}`,
    {
      method: 'DELETE',
      headers: {
        AuthKey: authToken,
      },
    },
  )

  if (!response.ok) {
    throw new Error('Failed to delete FCM token')
  }

  return parseResponseBody(response)
}
